import { render } from "./switch-base-plan-dialog.vue?vue&type=template&id=24a9c00a&scoped=true"
import script from "./switch-base-plan-dialog.vue?vue&type=script&lang=js"
export * from "./switch-base-plan-dialog.vue?vue&type=script&lang=js"

import "./switch-base-plan-dialog.vue?vue&type=style&index=0&id=24a9c00a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a9c00a"]])

export default __exports__